import { FC } from "react";

import Box from "@mui/material/Box";

import styles from "./styles";

type Loader3dProps = {
  label: string;
};
const Loader3d: FC<Loader3dProps> = ({ label }) => {
  const arr = Array.from({ length: 30 }, (_, index) => label[index]);

  return (
    <Box sx={styles.preloader}>
      <Box sx={styles.ring}>
        {arr.map((letter, index) => (
          <Box key={index} sx={(theme) => styles.sector(theme, { index })}>
            {letter}
          </Box>
        ))}
      </Box>
      <Box sx={styles.ring}>
        {arr.map((letter, index) => (
          <Box key={index} sx={(theme) => styles.sector(theme, { index })}>
            {letter}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Loader3d;
